import React from "react";
import { Space, Table, Tag } from "antd";
import "./CustomTable.css";

const CustomTable = ({ columns, data, ...rest }) => (
  <Table
    // className="CustomTable"
    columns={columns}
    dataSource={data}
    {...rest}
  />
);
export default CustomTable;
